import {
  Checkbox,
  Chip,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Box,
} from "@mui/material";
import { type FC } from "react";
import { useOrganization } from "../../contexts/OrganizationProvider";
import { useRequest } from "../../contexts/RequestProvider";
import { CheckboxIcon } from "@shared/frontend/icons";

export const PopulationSelect: FC = () => {
  const { currOrganization } = useOrganization();
  const { currentEvent, setCurrentEvent } = useRequest();

  const populations = (currOrganization?.populations || [])
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name));
  const selectedPopulations = currentEvent.selectedPopulations || [];

  const handleChange = (event: any) => {
    const {
      target: { value },
    } = event;
    const selectedIds = typeof value === "string" ? value.split(",") : value;
    const selected = populations.filter((p) => selectedIds.includes(p.id));
    setCurrentEvent((prev) => ({ ...prev, selectedPopulations: selected }));
  };

  if (!currOrganization) return null;

  return (
    <Stack className="field-container">
      <label className="field-label">אוכלוסיות יעד</label>
      <Select
        multiple
        slotProps={{
          root: { className: "field" },
        }}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            sx: {
              borderRadius: "20px",
            },
          },
        }}
        value={selectedPopulations.map((p: any) => p.id || p)}
        onChange={handleChange}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {(selected as string[]).map((id) => {
              const population = populations.find((p) => p.id === id);
              return <Chip key={id} label={population?.name || id} size="small" />;
            })}
          </Box>
        )}
      >
        {populations.map((population) => (
          <MenuItem key={population.id} value={population.id}>
            <Checkbox
              checkedIcon={<CheckboxIcon checked />}
              icon={<CheckboxIcon />}
              checked={selectedPopulations.some((p: any) => (p.id || p) === population.id)}
            />
            <ListItemText primary={population.name} />
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};
